import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@com/core/common/translations/i18n';
import BlockButton from './BlockButton';

type TProps = {
    titleKey: string;
    subtitleKey?: string;
    ctaClick: () => void;
    ctaTextKey: string;
    imgSrc?: string;
};

const ErrorBox = ({ ctaClick, ctaTextKey, imgSrc, subtitleKey, titleKey }: TProps): JSX.Element => {
    const { t } = useTranslation('common');
    const src = imgSrc || '/images/emptyStates/error.png';

    return (
        <ErrorBoxContainer>
            <Image src={src} alt="404" />
            <Title data-qa={`lbl_${titleKey}`}>{t(titleKey)}</Title>
            {!!subtitleKey && <Text data-qa={`lbl_${subtitleKey}`}>{t(subtitleKey)}</Text>}
            <ButtonContainer data-qa={`btn_${ctaTextKey}`}>
                <BlockButton variant="primary" onClick={ctaClick}>
                    {t(ctaTextKey)}
                </BlockButton>
            </ButtonContainer>
        </ErrorBoxContainer>
    );
};

const ErrorBoxContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

const Image = styled.img`
    max-width: 320px;
`;

const Title = styled.p`
    color: ${({ theme }): string => theme.colors.body};
    font-weight: 700;
    font-size: 1.5rem;
    margin: 15px;
`;

const Text = styled.p`
    color: ${({ theme }): string => theme.colors.body};
    font-size: 1.125rem;
`;

const ButtonContainer = styled.div`
    margin-top: 35px;
`;

export default ErrorBox;
